import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="w-full bg-ivory py-20 md:py-24" aria-labelledby="garantia" data-id="element-117" data-mp="4w1h0uw2z8jw">
      <div className="mx-auto max-w-3xl px-6 lg:px-8" data-id="element-118" data-mp="9tbdguhw0kh8">
        <Reveal data-id="element-119" data-mp="9wpe9yawklmk">
          <div className="rounded-[1.75rem] border border-goldsoft/60 bg-shell/50 px-8 py-12 text-center sm:px-14" data-id="element-120" data-mp="et620re6wxz4">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-goldsoft" data-id="element-121" data-mp="jtc0orivnkqp">
              <ShieldCheckIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-122" data-mp="nst5rjue6fvc" />
            </span>
            <h2 id="garantia" className="mt-6 font-display text-[2rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-123" data-mp="sm5iavlsqw7q">
              Garantía Volver a Ti
            </h2>
            <span aria-hidden="true" className="mx-auto mt-6 block h-[1px] w-12 bg-goldsoft" data-id="element-124" data-mp="12jjx6qs2ncxx" />
            <p className="mt-7 font-sans text-[1rem] font-light leading-[1.9] text-warmgray" data-id="element-125" data-mp="17hljdkksnsdm">
              Tienes 7 días para explorar este proceso. Si consideras que este material no era lo
              que esperabas, puedes solicitar tu devolución dentro del periodo establecido. Nuestro
              objetivo es que tengas una experiencia positiva.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}